<script lang="ts">
    type Props = {
        style?: string;
        width?: number;
        height?: number;
      };

        let { style = "", width = 24, height = 24 }: Props = $props();
</script>
<svg xmlns="http://www.w3.org/2000/svg" style={style} width={width} height={height} viewBox="0 0 24 24">
    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 4h4v4m-6 2l6-6M8 20H4v-4m0 4l6-6m6 6h4v-4m-6-2l6 6M8 4H4v4m0-4l6 6"/>
</svg>
